import { useEffect, useState } from 'react';
import { Badge } from 'antd';
import { Button, NotifOutlined } from 'pink-lava-ui';
import { useNotifications } from '../api/queries';
import NotificationModal from './NotificationModal';

export const HeaderNotification = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [page, setPage] = useState(1);

  const {
    data: notificationData,
    isLoading,
    refetch,
  } = useNotifications({
    page,
    limit: 10,
  });

  useEffect(() => {
    if (isNotificationOpen) {
      refetch();
    }
  }, [isNotificationOpen, refetch]);

  const unreadCount = notificationData?.data?.meta?.unread_notif || 0;

  return (
    <>
      <Badge offset={[-5, 5]} count={unreadCount}>
        <Button shape="circle" type="ghost" className="!text-gray-700" onClick={() => setIsNotificationOpen(true)}>
          <NotifOutlined height={20} width={20} />
        </Button>
      </Badge>
      <NotificationModal
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
        notificationResponse={notificationData?.data!}
        isLoading={isLoading}
        notifPage={page}
        setNotifPage={setPage}
      />
    </>
  );
};

export default HeaderNotification;
